import React from 'react';
import { useTranslation } from 'react-i18next';
import './GalleryPage.css';
import Header from '../components/Header';
import Footer from '../components/Footer';

const GalleryPage = () => {
  const { t } = useTranslation();
  const [dynamicImages, setDynamicImages] = React.useState([]);
  const [selectedImage, setSelectedImage] = React.useState(null);

  React.useEffect(() => {
    const isLocalHost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname.startsWith('192.168.') || window.location.hostname.startsWith('172.') || window.location.hostname.startsWith('10.') || window.location.port !== '';
    const envApiUrl = process.env.REACT_APP_API_URL?.trim();
    const API_URL = envApiUrl && (isLocalHost || (!envApiUrl.includes("localhost") && !envApiUrl.includes("127.0.0.1"))) ? envApiUrl : '/api';
    
    let backendBase = isLocalHost ? 'http://localhost:5000' : API_URL.replace('/api', '');
    if (!backendBase || backendBase.startsWith('/')) {
      backendBase = `${window.location.protocol}//${window.location.hostname}:5000`;
    }

    fetch(`${API_URL}/media/gallery`)
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setDynamicImages(data.data.map(img => img.url.startsWith('http') ? img.url : `${backendBase}${img.url.startsWith('/') ? '' : '/'}${img.url}`));
        }
      })
      .catch(err => console.error('Error fetching gallery:', err));
  }, []);

  const images = dynamicImages;

  return (
    <div className="gallery-page">
      <Header />
      
      <main className="gallery-main">
        <div className="container">
          <div className="gallery-header">
            <h1 className="gallery-title">{t('gallery_page.title')}</h1>
            <p className="gallery-subtitle">{t('gallery_page.subtitle')}</p>
          </div>
          
          {images.length > 0 ? (
            <div className="gallery-grid">
              {images.map((img, i) => (
                <div key={i} className="gallery-item" onClick={() => setSelectedImage(img)} style={{ cursor: 'pointer' }}>
                  <img src={img} alt={`Gallery ${i + 1}`} loading="lazy" />
                </div>
              ))}
            </div>
          ) : (
            <div style={{ textAlign: 'center', padding: '80px 0', color: '#64748b' }}>
              <p style={{ fontSize: '16px', fontWeight: '500' }}>No images uploaded in the gallery yet.</p>
              <p style={{ fontSize: '14px', marginTop: '4px' }}>Add images from the Admin Panel under CMS &gt; Gallery.</p>
            </div>
          )}
        </div>
      </main>

      {/* WhatsApp FAB */}
      <div className="whatsapp-fab" onClick={() => window.open('https://wa.me/919631277264', '_blank')}>
        <svg viewBox="0 0 24 24" width="32" height="32" fill="white">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.438 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.414 0 .004 5.412 0 12.046c0 2.123.555 4.195 1.608 6.014L0 24l6.117-1.605a11.782 11.782 0 005.925 1.587h.005c6.632 0 12.043-5.414 12.047-12.048a11.821 11.821 0 00-3.526-8.513"/>
        </svg>
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div 
          className="gallery-modal-overlay" 
          onClick={() => setSelectedImage(null)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.9)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
            cursor: 'zoom-out'
          }}
        >
          <button 
            onClick={() => setSelectedImage(null)}
            style={{
              position: 'absolute',
              top: '20px',
              right: '25px',
              background: 'none',
              border: 'none',
              color: 'white',
              fontSize: '40px',
              fontWeight: '300',
              cursor: 'pointer',
              lineHeight: 1
            }}
          >
            &times;
          </button>
          <img 
            src={selectedImage} 
            alt="Full Preview" 
            style={{
              maxWidth: '92%',
              maxHeight: '92%',
              objectFit: 'contain',
              borderRadius: '8px',
              boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
              transition: 'transform 0.3s ease'
            }} 
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}

      <Footer />
    </div>
  );
};

export default GalleryPage;


